import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'keysMapper'})
export class KeysMapperPipe implements PipeTransform {
    transform(keys: string[], mapper: { [k: string]: any } = {}): any[] {
        return keys.map(k => mapper[k]);
    }
}
